import { render, staticRenderFns } from "./dash.vue?vue&type=template&id=e753a528&scoped=true"
import script from "./dash.vue?vue&type=script&lang=ts"
export * from "./dash.vue?vue&type=script&lang=ts"
import style0 from "./dash.vue?vue&type=style&index=0&id=e753a528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e753a528",
  null
  
)

export default component.exports